export const LOCALSTORAGE_KEYS = {
  SESSION_EXPIRED_TOKEN: 'sessionExpired',
  USER_INFO_KEY: 'userInfo'
};
